import { createSelector } from 'reselect';
import { RootState } from '..';

const notificationsState = (state: RootState) => state.notifications;

export const selectNotifications = createSelector(notificationsState, (notifications) => notifications.notifications);
